import React from 'react';

const Features = () => {
    return (
        <div id="features" className="self-stretch px-8 py-16 bg-neutral-800 flex flex-col justify-center items-center gap-12 overflow-hidden">
            <div className="max-w-7xl mx-auto w-full">
                <div className="text-center mb-12">
                    <h2 className="!text-stone-300 text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">Job Responsibilities</h2>
                    <p className="!text-stone-300 text-lg font-medium font-['Inter']">Your digital teammate handles the full scope of front-desk operations.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="p-6 bg-gradient-to-br from-neutral-700 to-neutral-800 rounded-lg flex flex-col gap-4">
                        <div className="w-16 h-16 flex items-center justify-center">
                            <img src="/assets/smart-phone.svg" alt="Phone" className="w-16 h-16" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <h3 className="!text-white text-lg font-bold font-['Montserrat']">Full-Service Digital Front Desk</h3>
                            <p className="!text-white text-sm font-medium font-['Inter']">Always-On Office Coordination. Never miss a customer inquiry, day or night.</p>
                        </div>
                    </div>

                    <div className="p-6 bg-gradient-to-br from-neutral-700 to-neutral-800 rounded-lg flex flex-col gap-4">
                        <div className="w-16 h-16 flex items-center justify-center">
                            <img src="/assets/calendar.svg" alt="Calendar" className="w-16 h-16" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <h3 className="!text-stone-300 text-lg font-bold font-['Montserrat']">Schedule & Logistics Management</h3>
                            <p className="!text-stone-300 text-sm font-medium font-['Inter']">Seamlessly integrates with Google or Outlook calendars.</p>
                        </div>
                    </div>

                    <div className="p-6 bg-gradient-to-br from-neutral-700 to-neutral-800 rounded-lg flex flex-col gap-4">
                        <div className="w-16 h-16 flex items-center justify-center">
                            <img src="/assets/credit-card.svg" alt="Credit Card" className="w-16 h-16" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <h3 className="!text-stone-300 text-lg font-bold font-['Montserrat']">Financial & Deposit Handling</h3>
                            <p className="!text-stone-300 text-sm font-medium font-['Inter']">Validate payments directly during calls with PCI compliance.</p>
                        </div>
                    </div>

                    <div className="p-6 bg-gradient-to-br from-neutral-700 to-neutral-800 rounded-lg flex flex-col gap-4">
                        <div className="w-16 h-16 flex items-center justify-center">
                            <img src="/assets/mail.svg" alt="Mail" className="w-16 h-16" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <h3 className="!text-stone-300 text-lg font-bold font-['Montserrat']">Intelligent Staff Coordination</h3>
                            <p className="!text-stone-300 text-sm font-medium font-['Inter']">Closing the loop between callers and your on-site team.</p>
                        </div>
                    </div>

                    <div className="p-6 bg-gradient-to-br from-neutral-700 to-neutral-800 rounded-lg flex flex-col gap-4">
                        <div className="w-16 h-16 flex items-center justify-center">
                            <span className="text-4xl">🧠</span>
                        </div>
                        <div className="flex flex-col gap-2">
                            <h3 className="!text-stone-300 text-lg font-bold font-['Montserrat']">Learns Your Business</h3>
                            <p className="!text-stone-300 text-sm font-medium font-['Inter']">Point it to your website and it instantly knows your services, pricing, and policies. Answers customer questions accurately with source links via text.</p>
                        </div>
                    </div>

                    <div className="p-6 bg-gradient-to-br from-neutral-700 to-neutral-800 rounded-lg flex flex-col gap-4">
                        <div className="w-16 h-16 flex items-center justify-center">
                            <span className="text-4xl">🗣️</span>
                        </div>
                        <div className="flex flex-col gap-2">
                            <h3 className="!text-stone-300 text-lg font-bold font-['Montserrat']">Takes Direction Like an Employee</h3>
                            <p className="!text-stone-300 text-sm font-medium font-['Inter']">Just call or text your assistant to give instructions. "I'm in a meeting for 2 hours" or "We're closed tomorrow" — no dashboard needed.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Features;
